import { usuarioService, authService, fazendaService } from '../_services/';
import { history } from '../_helpers';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const usuarioAction = {
    getUsuario,
    getUsuariosFazenda,
    getUsuariosAdministradores,
    getUsuarioById,
    onChangeProps,
    onChangePropsAssinatura,
    onChangePropsObservacoes,
    editUsuarioInfo,
    createUsuario,
    deleteUsuarioById,
    clear,
    requestPasswordReset,
    passwordReset,
    getSelectUsuarios,
    getSelectAdministradores,
    getSelectInseminadores
};

function getUsuario(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'usuarios';
        usuarioService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeUsuariosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

function getUsuariosFazenda(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'usuarios/fazenda';
        usuarioService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeUsuariosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

function getUsuariosAdministradores(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'usuarios/administradores';
        usuarioService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeUsuariosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

function getSelectUsuarios(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'usuarios/select';
        usuarioService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Value: '0', Text: ' SELECIONE ...' });
                dispatch(changeUsuariosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

function getSelectAdministradores(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'usuarios/administradores/select';
        usuarioService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Value: '0', Text: ' SELECIONE ...' });
                dispatch(changeUsuariosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

function createUsuario(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'usuarios/';
        usuarioService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request != undefined && response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/usuarios');
                } else {
                    alerts.warning(response.data);
                }
            })
    }
}

function getUsuarioById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'usuarios/' + id;
        usuarioService.get(apiEndpoint)
            .then((response) => {
                dispatch(editUsuariosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

function getSelectInseminadores() {
    return dispatch => {
        let apiEndpoint = 'usuarios/inseminadores/select/';
        usuarioService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Value: '0', Text: ' SELECIONE ...' });
                dispatch(changeUsuariosList(response.data));
            }).catch((err) => {
                console.log(err);
            })
    };
}

function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type == 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}

function onChangePropsObservacoes(props, event) {
    return (dispatch) => {
        dispatch(handleOnChangeProps(props, event))
    }
}

function onChangePropsAssinatura(props, event) {
    return (dispatch) => {
        dispatch(handleOnChangeProps(props, event))
    }
}

function editUsuarioInfo(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'usuarios/' + id;
        usuarioService.put(apiEndpoint, payload)
            .then((response) => {
                if (response && response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/usuarios');
                } else {
                    alerts.warning(response.data);
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    }
}

function deleteUsuarioById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }

        fazendaService.get('fazendas/usuario/' + id)
            .then((response) => {
                if (response.request.status === 200) {
                    var listaFazendas = response.data;

                    let message = 'Tem certeza de que deseja excluir o registro?';
                    if (listaFazendas.length > 0) {
                        message += '\n\nO usuário está cadastrado nas seguintes fazendas:\n';
                        listaFazendas.forEach(fazenda => {
                            message += fazenda.Nome + "<br>";
                        });
                    } else {
                        message += '\n\nO usuário não está vinculado a nenhuma fazenda\n';
                    }

                    if (showWaiting) {
                        alerts.clean();
                    }

                    Swal.fire({
                        title: 'Confirmação',
                        icon: 'warning',
                        html: message,
                        buttons: true,
                        showCancelButton: true,
                        confirmButtonText: 'Sim',
                        cancelButtonText: "Não, cancelar!",
                        dangerMode: true,
                        heightAuto: false
                    })
                        .then((willDelete) => {
                            if (willDelete.value) {
                                let deleteEndpoint = 'usuarios/' + id;
                                usuarioService.deleteDetail(deleteEndpoint)
                                    .then((response) => {
                                        if (showWaiting) {
                                            alerts.waiting();
                                        }
                                        if (response.request.status === 200) {
                                            var ret = response.data;
                                            dispatch(deleteUsuariosDetails());
                                            if (showWaiting) {
                                                alerts.clean();
                                            }
                                            dispatch(getUsuario(true));
                                            alerts.success(ret.message);
                                        } else {
                                            alerts.warning(response.data);
                                        }
                                    }).catch((err) => {
                                        console.log(err.response);
                                        return err.response;
                                    });
                            }
                        });
                } else {
                    alerts.warning(response.data);
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            });
    };
}

function requestPasswordReset(payload) {
    return dispatch => {
        let apiEndpoint = 'usuarios/request-reset-password/';
        usuarioService.post(apiEndpoint, payload)
            .then((response) => {
                if (response && response.request.status === 200) {
                    dispatch(createUserInfo());
                    alerts.success('E-mail de recuperação enviado!', '/');
                }
                else if (response && response.request.status === 404) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Atenção',
                        text: 'Não existe nenhum usuário com este e-mail!'
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro ao recuperar senha do usuário!'
                    })
                }
            }).catch(err => {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Erro ao cadastrar usuário!'
                });
            });
    };
}

function passwordReset(payload, token) {
    return dispatch => {
        let apiEndpoint = 'usuarios/reset-password/';
        authService.postWithToken(apiEndpoint, payload, token)
            .then((response) => {
                if (response && response.request.status === 200) {
                    dispatch(createUserInfo());
                    alerts.success('Senha redefinida com sucesso!', '/');
                }
                else if (response && response.request.status === 404) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Atenção',
                        text: 'Não existe nenhum usuário com o e-mail informado!'
                    });
                }
                else if (response && response.request.status === 401) {

                    Swal.fire({
                        title: 'Atenção',
                        text: 'A validade desse link expirou. Deseja gerar um novo link de redefinição de senha?',
                        icon: 'warning',
                        buttons: true,
                        showCancelButton: true,
                        confirmButtonText: 'Sim',
                        cancelButtonText: "Não",
                        dangerMode: true,
                        heightAuto: false
                    })
                        .then((willDelete) => {
                            if (willDelete.value) {
                                history.push("/request-password-reset");
                            }
                        });

                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro ao recuperar senha do usuário!'
                    });
                }
            }).catch(err => {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Erro ao cadastrar usuário!'
                });
            });
    };
}
export function changeUsuariosList(usuario) {
    return {
        type: "FETECHED_ALL_USUARIO",
        usuario: usuario
    }
}
export function clear() {
    return {
        type: "USUARIO_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editUsuariosDetails(usuario) {
    return {
        type: "USUARIO_DETAIL",
        id: usuario.id,
        login: usuario.login,
        nome: usuario.nome,
        senha: usuario.senha,
        data_cadastro: usuario.data_cadastro,
        listaDispositivos: usuario.listaDispositivos,
        listaFazendas: usuario.listaFazendas,
        usuario_cadastro: usuario.usuario_cadastro,
        tipo: usuario.tipo,
        cpf: usuario.cpf,
        data_exclusao: usuario.data_exclusao,
        usuario_exclusao: usuario.usuario_exclusao,
        email: usuario.email,
        telefone: usuario.telefone,
        observacoes: usuario.observacoes,
        id_empresa: usuario.id_empresa,
        id_prefeitura: usuario.id_prefeitura,
        caminho_assinatura: usuario.caminho_assinatura,
        modulo_financeiro: usuario.modulo_financeiro
    }
}
export function updatedUserInfo() {
    return {
        type: "USUARIO_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "USUARIO_CREATED_SUCCESSFULLY"
    }
}
export function deleteUsuariosDetails() {
    return {
        type: "DELETED_USUARIO_DETAILS"
    }
}